import React, { useEffect } from "react";
import { loginRequest } from "./components/lib/auth/msalConfig.ts";
import { InteractionType } from "@azure/msal-browser";
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
  useMsalAuthentication,
} from "@azure/msal-react";
import App from "./App";
import { msalInstance } from "./components/lib/auth/msalInstance.ts";

function AuthGate() {
  const { error } = useMsalAuthentication(
    InteractionType.Redirect,
    loginRequest,
  );

  if (error) {
    return <p>Authentication error: {error.message}</p>;
  }

  return (
    <>
      <AuthenticatedTemplate>
        <App />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <p>Redirecting to sign in…</p>
      </UnauthenticatedTemplate>
    </>
  );
}

export default function Layout() {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthGate />
    </MsalProvider>
  );
}
